import type { ReactNode } from 'react';

import { Navigate } from 'react-router-dom';

import type { StaffRole } from '@/store/authStore';
import { useAuthStore } from '@/store/authStore';

interface Props {
  roles: StaffRole[];
  children: ReactNode;
}

export function RequireRole({ roles, children }: Props) {
  const staff = useAuthStore((s) => s.staff);

  if (!staff) {
    return <Navigate to="/login" replace />;
  }

  if (!roles.includes(staff.role)) {
    return <Navigate to="/forbidden" replace />;
  }

  return <>{children}</>;
}
